import type { ReactElement } from 'react'
import { ProcedureVolumeReport } from '@/components/reports/procedures/ProcedureVolumeReport'
import { ProcedureThroughputReport } from '@/components/reports/procedures/ProcedureThroughputReport'
import { ProcedureOnTimeReport } from '@/components/reports/procedures/ProcedureOnTimeReport'
import { ProcedureTurnaroundReport } from '@/components/reports/procedures/ProcedureTurnaroundReport'
import { ProcedureBacklogReport } from '@/components/reports/procedures/ProcedureBacklogReport'
import { InventoryStockReport } from '@/components/reports/inventory/InventoryStockReport'
import { InventoryConsumptionReport } from '@/components/reports/inventory/InventoryConsumptionReport'
import { InventoryExpiryReport } from '@/components/reports/inventory/InventoryExpiryReport'
import type { ReportFilterSelection } from '@/lib/reportFilters'
import type { ReportTimeFrame } from '@/lib/reportRange'

export type ReportBodyProps = { frame: ReportTimeFrame; filters: ReportFilterSelection }

/**
 * Which component renders which report, keyed by catalog id.
 *
 * THE single source of truth for "is this report built". It lives in its own
 * module because two surfaces need it and they must never disagree: the detail
 * pane renders from it, and the tree greys a report that is not in it.
 *
 * The catalog's `status` cannot serve that purpose — it is hand-maintained, and
 * it drifted: every report in sections 1 and 2 still said `planned` after being
 * implemented. A list you have to remember to update is a list that lies, so
 * membership HERE — which is what actually decides whether a report renders —
 * is what the tree reads.
 */
export const BUILT: Record<string, (props: ReportBodyProps) => ReactElement | null> = {
  '1.1': ProcedureVolumeReport,
  '1.2': ProcedureThroughputReport,
  '1.3': ProcedureOnTimeReport,
  '1.4': ProcedureTurnaroundReport,
  '1.5': ProcedureBacklogReport,
  '2.1': InventoryStockReport,
  '2.2': InventoryConsumptionReport,
  '2.3': InventoryExpiryReport,
}

/** Is this report runnable today? */
export function isBuilt(reportId: string): boolean {
  return reportId in BUILT
}
